import classnames from 'classnames';
import { ComponentPropsWithoutRef } from 'react';
import { FeaturedPost as FeaturedPostDto } from '../../../../../../../store/api-slices';
import { Button } from '@mui/material';

type FeaturedPostProps = ComponentPropsWithoutRef<'article'> & {
  post: FeaturedPostDto;
};

const FeaturedPost = ({ className, post, ...rest }: FeaturedPostProps) => {
  const hasButton = post.button_text && post.button_url;

  return (
    <article className={classnames('space-y-md p-md shadow border bg-white rounded-xl', className)} {...rest}>
      {post.image && <img className="rounded-lg object-contain w-full" loading="lazy" src={post.image} alt="Post" />}
      <h3 className="font-bold text-brand-primary text-base">{post.title}</h3>
      {post.description && <p className="font-medium text-sm text-brand-text-secondary">{post.description}</p>}
      {hasButton && (
        <Button
          onClick={() => window.open(post.button_url, '_blank')}
          className="!bg-brand-primary !text-white !p-3 !rounded-lg !font-normal !text-base !min-w-40 !capitalize"
        >
          {post.button_text}
        </Button>
      )}
    </article>
  );
};

export default FeaturedPost;
